import {colors} from "styles";
import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  border-radius: 5px;
  border-bottom: 0.3px solid
    ${({theme}) => (theme["isDark"] ? colors["white01"] : colors["black01"])};
  &:hover {
    background-color: ${({theme}) => theme["hover"]};
  }
  &:last-child {
    border-bottom: unset;
  }
`;
